// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";

function CustomSidebar(Props) {
  var is_open = Props.is_open;
  var on_back_drop_click = Props.on_back_drop_click;
  var children = Props.children;
  if (is_open) {
    return React.createElement("div", {
                className: "c-custom-sidebar"
              }, React.createElement("div", {
                    className: "backdrop",
                    onClick: (function (param) {
                        return Curry._1(on_back_drop_click, undefined);
                      })
                  }), React.createElement("div", {
                    className: "content"
                  }, children));
  } else {
    return null;
  }
}

var make = CustomSidebar;

export {
  make ,
  
}
/* react Not a pure module */
